import React from "react";
import { Line } from "react-chartjs-2";
import {
  CategoryScale,
  Chart as Chartjs,
  LineElement,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
  Filler,
} from "chart.js";

Chartjs.register(
  LineElement, 
  CategoryScale, 
  LinearScale, 
  PointElement, 
  Legend,
  Tooltip,
  Filler
);

const LineChart = ({ data, options, title }) => {
  return (
    <>
      <Line data={data} options={options} />
      {/* <h4>{title}</h4> */}
    </>
  );
};

export default LineChart;
